// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./resources/assets/sass/admin/core.scss
// module id = 13
// module chunks = 0